/* Money + amount formatters used across terminal panes. Money is
   stored as strings everywhere (per backend convention), so these
   helpers also accept strings and convert defensively. */

const num = (n) => (typeof n === "number" ? n : parseFloat(n) || 0);

export const fmtUSD  = (n) => "$" + Math.round(num(n)).toLocaleString("en-US");
export const fmtUSD2 = (n) => "$" + num(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const fmtNum  = (n, dec = 2) => num(n).toLocaleString("en-US", { minimumFractionDigits: dec, maximumFractionDigits: dec });

export const fmtCcy = (n, ccy) => {
  const dec = (ccy === "BTC" || ccy === "ETH") ? 4
            : (ccy === "JPY" || ccy === "AED") ? 0
            : 2;
  return num(n).toLocaleString("en-US", { minimumFractionDigits: dec, maximumFractionDigits: dec }) + " " + ccy;
};

export const fmtAbbr = (n) => {
  const v = num(n);
  const a = Math.abs(v);
  const sign = v < 0 ? "-" : "";
  if (a >= 1_000_000_000) return `${sign}$${(a/1_000_000_000).toFixed(2)}B`;
  if (a >= 1_000_000)     return `${sign}$${(a/1_000_000).toFixed(2)}M`;
  if (a >= 1_000)         return `${sign}$${(a/1_000).toFixed(0)}K`;
  return `${sign}$${a.toFixed(0)}`;
};

export const signedAbbr = (n) => {
  const v = num(n);
  if (v >= 0) return "+" + fmtAbbr(v);
  return fmtAbbr(v); // already has -
};
